import type { RisingCreatorSource } from '../../hooks/useRisingCreators';

const SOURCE_CONFIG: Record<RisingCreatorSource, { label: string; className: string }> = {
  hashtag: { label: 'Hashtag', className: 'bg-blue-100 text-blue-700' },
  follow_graph: { label: 'Follow graph', className: 'bg-teal-100 text-teal-700' },
  tiktok_rising: { label: 'TikTok Rising', className: 'bg-gray-900 text-white' },
  sponsored_collab: { label: 'Collab sponsorisée', className: 'bg-pink-100 text-pink-700' },
};

export default function SourceBadge({ source }: { source: RisingCreatorSource }) {
  const config = SOURCE_CONFIG[source] || SOURCE_CONFIG.hashtag;
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-md text-xs font-medium ${config.className}`}>
      {config.label}
    </span>
  );
}
